import { blogArticles } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

export default function BlogSection() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    navigate(`/artigo/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative bg-background-100 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12 md:mb-16">
          <p className="text-foreground-400 text-xs md:text-sm font-semibold uppercase tracking-[0.2em] mb-3">
            Blog &amp; Guias
          </p>
          <h2 className="font-heading text-foreground-900 text-3xl md:text-5xl font-black leading-tight">
            Artigos sobre
            <br />
            <span className="italic font-light">CSSBuy Sheet</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-4 max-w-xl leading-relaxed">
            Explore nossa coleção completa de artigos e guias para dominar o CSSBuy Spreadsheet. Conteúdo original e atualizado para todos os níveis.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogArticles.map((article, index) => (
            <button
              key={`${article.slug}-${index}`}
              onClick={() => handleArticleClick(article.slug)}
              className="group text-left bg-background-50 rounded-2xl overflow-hidden hover:bg-background-200/30 transition-all duration-300 cursor-pointer w-full"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={index < 6 ? 'eager' : 'lazy'}
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-50 text-foreground-900 mb-4">
                  <i className={`${article.icon} text-lg`}></i>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4 line-clamp-3">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-700 group-hover:text-foreground-900 transition-colors">
                  Leia mais
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}